import React from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { t } from 'ttag'
import { updateSelectedFilters } from 'store/actions/filters'
import SearchFilter from 'components/ui/SearchFilter'
import SelectedFilter from 'components/ui/SelectedFilter'
import FilterText from 'components/ui/FilterText'
import RemoveIcon from 'components/ui/RemoveIcon'
import CustomCheckbox from 'components/ui/CustomCheckbox'
import SelectedFilterContainer from 'components/ui/SelectedFilterContainer'
import { SELECTED_FILTER_MAX_LINES } from 'store/constants/constants'
import Dotdotdot from 'react-dotdotdot'

const FilterSection = styled.div`
  margin-bottom: 0px;
`

const Input = styled.input`
  margin-right: 5px;
`

const Label = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: #4a4a4a;
`

function Calls({ type, title, showFilter, customTop, hide, instant, subTitle, selection }) {
  const filters = useSelector(state => state.filters)
  const { currentSearchable } = filters
  let checkboxSelected =
    filters.selectedFilters[currentSearchable][type].call == 'ongoing' ? true : false
  if (!checkboxSelected) checkboxSelected = false

  return (
    <PureCalls
      type={type}
      title={title}
      showFilter={showFilter}
      customTop={customTop}
      checkboxSelected={checkboxSelected}
      instant={instant}
      hide={hide}
      subTitle={subTitle}
      selection={selection}
    />
  )
}

const PureCalls = React.memo(function PureCalls({
  type,
  title,
  showFilter,
  customTop,
  selection,
  checkboxSelected,
  instant,
  subTitle
}) {
  const dispatch = useDispatch()

  function handleCheckboxChange() {
    const checked = checkboxSelected ? '' : 'ongoing'
    const data = {
      filterType: type,
      filterId: 'call',
      filterValue: checked
    }
    dispatch(updateSelectedFilters(data))
  }

  function handleFilterRemove(filterId) {
    const resultingValue = null
    const data = {
      filterType: type,
      filterId,
      filterValue: resultingValue
    }
    dispatch(updateSelectedFilters(data))
  }

  function renderSelectedValues() {
    if (checkboxSelected) {
      const filterValue = checkboxSelected
      if (filterValue != null && !instant) {
        const selectedFilterText = t`Show only programmes with calls ongoing`
        return (
          <SelectedFilterContainer className="selected-filters">
            <SelectedFilter>
              <FilterText title={selectedFilterText}>
                <Dotdotdot clamp={SELECTED_FILTER_MAX_LINES}>{selectedFilterText}</Dotdotdot>
              </FilterText>
              <RemoveIcon className="far fa-times" onClick={() => handleFilterRemove('call')} />
            </SelectedFilter>
          </SelectedFilterContainer>
        )
      }
      return false
    }
    return false
  }

  return (
    <>
      {instant ? (
        <SearchFilter open={showFilter}>
          <div className="sticky-container">
            <FilterSection>
              <CustomCheckbox>
                <Input
                  type="checkbox"
                  id="call"
                  name="filter-checkbox"
                  value="ongoing"
                  checked={checkboxSelected ? 'checked' : ''}
                  onChange={handleCheckboxChange}
                />
                <Label htmlFor="call">
                  <div className="meta-info">
                    <div className="title">{title}</div>
                    <div className="sub-title">{subTitle}</div>
                  </div>
                  <div className="checkbox"></div>
                </Label>
              </CustomCheckbox>
            </FilterSection>
          </div>
        </SearchFilter>
      ) : (
        <>
          {!selection ? (
            <SearchFilter open={showFilter} customTop={customTop}>
              <FilterSection>
                <CustomCheckbox>
                  <Input
                    type="checkbox"
                    id="call"
                    name="filter-checkbox"
                    value="ongoing"
                    checked={checkboxSelected ? 'checked' : ''}
                    onChange={handleCheckboxChange}
                  />
                  <Label htmlFor="call">{t`Show only programmes with calls ongoing`}</Label>
                </CustomCheckbox>
              </FilterSection>
            </SearchFilter>
          ) : (
            <div className="selected-fl">{renderSelectedValues()}</div>
          )}
        </>
      )}
    </>
  )
})

Calls.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string,
  hide: PropTypes.bool,
  instant: PropTypes.bool,
  subTitle: PropTypes.string,
  selection: PropTypes.bool
}

PureCalls.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  showFilter: PropTypes.bool,
  customTop: PropTypes.string,
  checkboxSelected: PropTypes.bool,
  hide: PropTypes.bool,
  instant: PropTypes.bool,
  subTitle: PropTypes.string,
  selection: PropTypes.bool
}

export default Calls
